export default __webpack_public_path__ + "static/media/downArrowIcon.6de30097.svg";